import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Agenda from "@/pages/Agenda";
import Rad from "@/pages/Rad";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/agenda" element={<Agenda />} />
          <Route path="/rad" element={<Rad />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: {
            background: 'rgba(22, 15, 36, 0.95)',
            border: '1px solid rgba(229, 185, 66, 0.3)',
            color: '#F8F5FF',
            backdropFilter: 'blur(20px)',
          },
        }}
      />
    </div>
  );
}

export default App;
